import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import tr from './locales/tr.json';
import en from './locales/en.json';

// EN/TR — varsayılan TR. Seçim localStorage'da (ktp_site_lang) saklanır.
//
// Tarayıcı dili BİLEREK algılanmıyor: Googlebot İngilizce tarayıcıyla render
// ettiği için site Google'da İngilizce indeksleniyordu. İngilizce yalnızca dil
// butonuyla seçilir (bkz. ThemeLangControls).
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: { translation: tr },
      en: { translation: en },
    },
    fallbackLng: 'tr',
    supportedLngs: ['tr', 'en'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'ktp_site_lang',
    },
  });

export default i18n;
